import { useEffect, useState } from 'react';
import cdoItem from '../cdo/cdoItem';

export default function ItemConsumptionSettings({ itemId }) {
  const [dose, setDose] = useState('');
  const [status, setStatus] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (!itemId) return undefined;
    let cancelled = false;
    setDose(''); setStatus('');
    cdoItem.consumptionProfile(itemId, (error, value) => {
      if (!cancelled) {
        if (error || value?.error) setStatus('Consumption settings unavailable. Install play3-consumables.sql first.');
        else setDose(value?.consumptionDoseAmount ?? '');
      }
    });
    return () => { cancelled = true; };
  }, [itemId]);
  if (!itemId) return null;
  const save = () => {
    setSaving(true); setStatus('');
    cdoItem.saveConsumptionProfile({ idEntity: itemId, consumptionDoseAmount: dose === '' ? null : Number(dose) }, (error, value) => {
      setSaving(false); setStatus(error || value?.error ? 'Consumption settings could not be saved.' : 'Consumption settings saved.');
    });
  };
  return <fieldset className="editor-section">
    <legend>Consumption</legend>
    <label className="editor-field">Dose amount
      <input type="number" min="0.000001" step="any" value={dose} onChange={event => setDose(event.target.value)} />
    </label>
    <p>Optional: the amount in this item's provision quantity or container volume units for one dose. A charged item without provisions uses one dose.
      Leave blank for ordinary food or nonconsumable equipment. Potion effects use its saved Single Use Life or Self Healing spells and levels.</p>
    <button type="button" onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save consumption settings'}</button>
    {status && <p role="status">{status}</p>}
  </fieldset>;
}
